import { Flex, Box } from '@chakra-ui/react';
import { LuSearch, LuX } from 'react-icons/lu';
import type { MenuTheme } from '../../api/menus';

interface SearchBarProps {
  query: string;
  onChange: (q: string) => void;
  placeholder: string;
  theme: MenuTheme;
  hoverBg: string;
}

const SearchBar = ({ query, onChange, placeholder, theme: mt, hoverBg }: SearchBarProps) => (
  <Box px="20px" pt="12px">
    <Flex
      alignItems="center"
      gap="8px"
      px="12px"
      py="8px"
      borderRadius="8px"
      backgroundColor={hoverBg}
      borderWidth="1px"
      borderColor={mt.border_color}
    >
      <LuSearch size={16} style={{ color: mt.secondary_text_color, flexShrink: 0 }} />
      <input
        type="text"
        value={query}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          flex: 1,
          fontSize: '14px',
          fontWeight: 400,
          color: mt.text_color,
          backgroundColor: 'transparent',
          border: 'none',
          outline: 'none',
        }}
      />
      {query && (
        <Box
          cursor="pointer"
          flexShrink={0}
          onClick={() => onChange('')}
          color={mt.secondary_text_color}
          _hover={{ color: mt.text_color }}
        >
          <LuX size={14} />
        </Box>
      )}
    </Flex>
  </Box>
);

export default SearchBar;
